interface ProgressBarProps {
	progress: number
	className?: string
	showPercentage?: boolean
}

export default function ProgressBar({ progress, className, showPercentage }: ProgressBarProps) {
	const roundedProgress = Math.floor(progress)
	const sanitizedProgress = Math.min(Math.max(roundedProgress, 0), 100)

	const height = showPercentage ? 'h-4' : 'h-2'

	return (
		<div className={className}>
			<div className={`relative w-full ${height} bg-gray-200 rounded-full dark:bg-gray-800 overflow-x-hidden`}>
				<div
					style={{ width: `${sanitizedProgress}%` }}
					className={`absolute left-0 h-full bg-brand-500 rounded-full flex items-center justify-center text-white font-medium text-[10px] leading-tight`}
				>
					{showPercentage && <span>{sanitizedProgress}%</span>}
				</div>
			</div>
		</div>
	)
}
